module.exports = __webpack_public_path__ + "img/function04.3e0e7c42.png";